module.exports = __webpack_public_path__ + "img/snowflake.f0440d83.png";